/**
 * @fileoverview Layout component for the application.
 * This component provides the structure for the application, including the side menu, protected routes, and toast notifications.
 * It also initializes Intercom for user tracking.
 */

import { useState } from 'react'
import { Outlet } from 'react-router-dom'
// import { useIntercom } from '../hooks/useIntercom'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { ModalAPIContext } from './modals/Context'
import { ProtectedRoute } from './ProtectedRoute'
import { SideMenu } from './SideMenu'
import { ToastAPIContext } from './toasts/ToastContext'

/**
 * @function Layout
 * @description Main layout component for the application.
 * @returns {JSX.Element | null} - The Layout component.
 */
export function Layout() {
    const [, get] = useLocalStorage()
    const [isIntercomInitialized, setIntercomInitialized] = useState(false)
    const user = get('user') as Novoic.API.User | undefined
    const intercom = get('intercom') as Record<string, string> | undefined
    // const initializeIntercom = useIntercom()

    // useEffect(() => {
    //     if (!isIntercomInitialized && user && intercom) {
    //         initializeIntercom({
    //             user_id: intercom.user_id,
    //             user_hash: intercom.hash,
    //             email: user?.email,
    //         })

    //         setIntercomInitialized(true)
    //     }
    // }, [user, intercom])

    return (
        <ToastAPIContext>
            <ModalAPIContext>
                <div className="flex w-full h-full min-h-screen">
                    <SideMenu />
                    <section className="w-full ml-64">
                        <ProtectedRoute>
                            <Outlet />
                        </ProtectedRoute>
                    </section>
                </div>
            </ModalAPIContext>
        </ToastAPIContext>
    )
}
